import C from "../constants";

export default function source(state = {}, payload) {
  let { type, key, data } = payload;
  switch (type) {
    case C.UPDATE_SOURCE_INPUT:
      return { ...state, [key]: data };
    default:
      return state;
  }
}
